import React, { useState } from "react";
import { Card } from "react-bootstrap";
import DataTable from "../table/DataTable";
import CommonButton from "../Input/CommonButton";
import CommonModal from "../Input/CommonModal";
import CommonInput from "../Input/CommonInput";
import { showNotification } from "../Common/CommonNotification";

const ApiManagement = () => {
  const [apiData, setApiData] = useState([
    {
      no: "51",
      name: "sparkminds",
      apiKey: "api_key_777085b*************************",
    },
  ]);

  const [showConfirm, setShowConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [showCreateStep1, setShowCreateStep1] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newKey, setNewKey] = useState("");
  const [newLabel, setNewLabel] = useState("");
  const [modalMode, setModalMode] = useState("regenerate"); // "regenerate" or "create"

  const generateRandomKey = () => {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let key = "api_key_";
    for (let i = 0; i < 32; i++) {
      key += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return key;
  };

  const handleCreateClick = () => {
    setNewLabel("");
    setShowCreateStep1(true);
  };

  const handleNextStep1 = () => {
    const generatedKey = generateRandomKey();
    setNewKey(generatedKey);
    setModalMode("create");
    setShowCreateStep1(false);
    setShowResult(true);
  };

  const handleRefreshClick = (item) => {
    setSelectedItem(item);
    setModalMode("regenerate");
    setShowConfirm(true);
  };

  const handleConfirmRegenerate = () => {
    const generatedKey = generateRandomKey();
    setNewKey(generatedKey);
    setShowConfirm(false);
    setShowResult(true);
  };

  const handleFinalConfirm = () => {
    if (modalMode === "create") {
      const nextNo =
        apiData.length > 0
          ? (
              Math.max(...apiData.map((item) => parseInt(item.no))) + 1
            ).toString()
          : "1";
      const newEntry = {
        no: nextNo,
        name: newLabel || "unnamed",
        apiKey: generatedKeyDisplay(newKey),
      };
      setApiData((prev) => [...prev, newEntry]);
    } else if (selectedItem) {
      setApiData((prev) =>
        prev.map((item) =>
          item.no === selectedItem.no
            ? {
                ...item,
                apiKey: generatedKeyDisplay(newKey),
              }
            : item,
        ),
      );
    }
    setShowResult(false);
    setSelectedItem(null);
    setNewKey("");
    setNewLabel("");
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = () => {
    if (selectedItem) {
      setApiData((prev) => prev.filter((item) => item.no !== selectedItem.no));
    }
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const handleCopyKey = (key) => {
    navigator.clipboard.writeText(key);
    showNotification("API Key copied to clipboard!", "success");
  };

  const generatedKeyDisplay = (key) => {
    return key.substring(0, 15) + "*************************";
  };

  const columns = [
    {
      label: "No",
      key: "no",
      className: "ps-4",
    },
    {
      label: "Name",
      key: "name",
      className: "ps-4",
    },
    {
      label: "API key",
      key: "apiKey",
      className: "ps-4",
    },
    {
      label: "Action",
      key: "action",
      className: "ps-4",
      render: (item) => (
        <div className="d-flex align-items-center gap-3">
          <i
            className="fas fa-sync-alt cursor-pointer text-muted hover-primary"
            title="Refresh"
            onClick={() => handleRefreshClick(item)}
          ></i>
          <i
            className="far fa-trash-alt cursor-pointer text-danger"
            title="Delete"
            onClick={() => handleDeleteClick(item)}
          ></i>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-black mb-0">API Management</h2>
        <CommonButton
          variant="primary"
          className="d-flex align-items-center"
          onClick={handleCreateClick}
        >
          <i className="fas fa-plus me-2 fs-12"></i> Create API
        </CommonButton>
      </div>

      <Card className="border-0 shadow-sm rounded-4 overflow-hidden mt-4">
        <Card.Body className="p-4">
          <DataTable
            data={apiData}
            columns={columns}
            showPagination={false}
            minWidth="100%"
          />
        </Card.Body>
      </Card>

      {/* Create API Step 1 Modal */}
      <CommonModal
        show={showCreateStep1}
        onHide={() => setShowCreateStep1(false)}
        title="Create API Key"
        size="md"
        centered
        headerClassName="pb-1"
        footer={
          <div className="d-flex gap-2 justify-content-end w-100">
            <CommonButton
              variant="light"
              className="border py-1"
              onClick={() => setShowCreateStep1(false)}
            >
              Cancel
            </CommonButton>
            <CommonButton
              variant="primary"
              onClick={handleNextStep1}
              disabled={!newLabel.trim()}
              style={{
                backgroundColor: newLabel.trim() ? "#00264D" : "#8294ad",
                borderColor: newLabel.trim() ? "#00264D" : "#8294ad",
              }}
            >
              Next
            </CommonButton>
          </div>
        }
      >
        <div className="mb-2">
          <p className="fw-bold text-black mb-2">
            Label your API Key to proceed
          </p>
          <CommonInput
            placeholder="Enter label"
            value={newLabel}
            onChange={(e) => setNewLabel(e.target.value)}
            height="45px"
          />
        </div>
      </CommonModal>

      {/* Confirmation Modal */}
      <CommonModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        title="Confirmation"
        size="md"
        centered
        headerClassName="pb-1"
        footer={
          <div className="d-flex gap-2 justify-content-end w-100">
            <CommonButton
              variant="light"
              className="border py-1"
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </CommonButton>
            <CommonButton variant="primary" onClick={handleConfirmRegenerate}>
              Confirm
            </CommonButton>
          </div>
        }
      >
        <p className="text-muted mb-2">
          Are you sure you want to regenerate this API Key?
        </p>
      </CommonModal>

      {/* Result Modal */}
      <CommonModal
        show={showResult}
        onHide={() => setShowResult(false)}
        title="Create API Key"
        size="md"
        centered
        headerClassName="pb-1"
      >
        <div className="mb-3">
          <p className="fs-14 fw-bold text-black mb-2">
            For security reason, by design, Secret keys are only visible at the
            time API key is created.
          </p>
          <div className="position-relative">
            <CommonInput
              value={newKey}
              readOnly
              height="40px"
              className="bg-light-blue border-0 fs-13"
              style={{ paddingRight: "40px", backgroundColor: "#f0f4f9" }}
            />
            <i
              className="far fa-copy position-absolute cursor-pointer text-muted"
              style={{
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
              onClick={() => handleCopyKey(newKey)}
            ></i>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <CommonButton variant="primary" onClick={handleFinalConfirm}>
            Confirm
          </CommonButton>
        </div>
      </CommonModal>

      {/* Delete Confirmation Modal */}
      <CommonModal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}
        title="Confirmation"
        size="md"
        centered
        headerClassName="pb-1"
        footer={
          <div className="d-flex gap-2 justify-content-end w-100">
            <CommonButton
              variant="light"
              className="border py-1"
              onClick={() => setShowDeleteConfirm(false)}
            >
              Cancel
            </CommonButton>
            <CommonButton
              variant="danger"
              onClick={handleConfirmDelete}
              style={{ minWidth: "90px" }}
            >
              Delete
            </CommonButton>
          </div>
        }
      >
        <p className="text-muted mb-2">
          Are you sure you want to delete this API Key?
        </p>
      </CommonModal>

      <style>{`
        .hover-primary:hover {
            color: var(--primary) !important;
        }
        .fs-12 { font-size: 12px; }
        .fs-13 { font-size: 13px; }
        .fs-14 { font-size: 14px; }
        .bg-light { background-color: #f8f9fa !important; }
        .bg-light-blue { background-color: #f0f4f9 !important; }
        
        .finance-common-modal .modal-dialog {
           max-width: 450px !important;
        }
        .finance-common-modal .modal-body {
           padding-top: 5px !important;
           padding-bottom: 20px !important;
        }
      `}</style>
    </div>
  );
};

export default ApiManagement;
